import { History } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { PackagingItemChangeHistoryEntry } from '@/shared/packagingItemChangeHistory'
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import { PackagingItemChangeHistoryTable } from './PackagingItemChangeHistoryTable'

type PackagingItemChangeHistoryTabProps = {
  history: PackagingItemChangeHistoryEntry[]
  locale: string
}

export function PackagingItemChangeHistoryTab({
  history,
  locale,
}: PackagingItemChangeHistoryTabProps) {
  const { t } = useTranslation('packagingSuppliers')

  if (history.length === 0) {
    return (
      <Empty className='rounded-lg border border-dashed py-12'>
        <EmptyHeader>
          <EmptyMedia variant='icon'>
            <History className='size-10' />
          </EmptyMedia>
          <EmptyTitle>{t('itemDetail.changeHistory.empty')}</EmptyTitle>
        </EmptyHeader>
      </Empty>
    )
  }

  return (
    <PackagingItemChangeHistoryTable history={history} locale={locale} />
  )
}
